<template>
  <div class="settings-move-patient-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Move Patient</h5>
    </div>
    <b-row>
      <b-col cols="3">
        <b-form-group
          label="Patient"
          :state="formErrors.eoc.length == 0 && formErrors.tabOpen.length == 0 ? null : false"
          :invalid-feedback="formErrors.eoc.join(', ') + formErrors.tabOpen.join(', ')"
        >
          <eoc-picker
            :eocs="episodesOfCare"
            v-model="selectedEoc"
            :async="true"
            @search="
              ({ search, loading }) => fetchEocsOptionsPicker(search, loading)
            "
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group
          label="Location"
          :state="formErrors.location.length == 0 ? null : false"
          :invalid-feedback="formErrors.location.join(', ')"
        >
          <v-select class="" :options="locations" v-model="selectedLocation" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-button class="ml-2" @click="movePatient()" variant="primary">
      Move patient
    </b-button>
  </div>
</template>

<script>
import { mapActions,mapState } from "vuex";
import eocServer from "../../server/eoc";
import locationServer from "../../server/location";
import EocPicker from "../controls/EocPicker";
import { validateRequired } from "../../helpers/validation";

export default {
  name: "MovePatient",
  components: { EocPicker },
  data() {
    return {
      form: {
        eoc: null,
        location: null
      },
      formErrors: {
        eoc: [],
        location: [],
        tabOpen: []
      },
      episodesOfCare: [],
      locations: []
    };
  },
  mounted() {
    this.fetchEocs();
    this.fetchLocations();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    clearForm() {
      this.form.eoc = null;
      this.form.location = null;
    },
    validateForm() {
      let withoutErrors = true;

      this.formErrors.eoc = [];
      if (!validateRequired(this.form.eoc)) {
        this.formErrors.eoc.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.location = [];
      if (!validateRequired(this.form.location)) {
        this.formErrors.location.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.tabOpen = [];
      this.eocTabs.forEach(t => {
        if (t.props.eocId && t.props.eocId == this.form.eoc.value){
          this.formErrors.tabOpen.push("Please close the tab for this patient before moving to another location!")
          withoutErrors = false;
        }
      })
      return withoutErrors;
    },
    async fetchEocsOptionsPicker(search, loading) {
      if (this.lastTimeoutEocsOptionsPicker) {
        clearTimeout(this.lastTimeoutEocsOptionsPicker);
        this.lastTimeoutEocsOptionsPicker = null;
      }
      if (search && search.trim().length >= 3) {
        this.episodesOfCare = [];
      }
      this.lastTimeoutEocsOptionsPicker = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          if (search.length >= 3) {
            loading(true);
          }

          this.searchingEocs = true;
          const optionsResult = await eocServer.queryList(
            {
              searchPhrase: search,
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : [],
              locations: this.locationId ? [this.locationId] : [],
              page: 1,
              pageSize: 50
            },
            {
              "Hide-Loading": true
            }
          );

          this.episodesOfCare = optionsResult.episodesOfCare.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          this.searchingEocs = false;
          if (search.length >= 3) {
            loading(false);
          }
        }
      }, 1000);
    },
    async fetchEocs() {
      const optionsResult = await eocServer.queryList(
        {
          searchPhrase: "",
          eocStatus: ["Active", "Pending"],
          locationId: [],
          allLocations: true,
          page: 1,
          pageSize: 50
        },
        {
          "Hide-Loading": true
        }
      );
      this.episodesOfCare = optionsResult.episodesOfCare.map(eoc => ({
        value: eoc.id,
        label: this.formatEocObj(eoc),
        data: eoc
      }));
    },
    async fetchLocations() {
      const allLocations = await locationServer.query({});
      this.locations = allLocations.map(x => ({
        value: x.id,
        label: x.name
      }));
    },
    async movePatient() {
      const result = await this.validateForm();
      if (result) {
        await eocServer.updateLocation(
          this.form.eoc.value,
          this.form.location.value
        );
        this.showAlertSuccess();
        this.clearForm();
      }
    }
  },
  computed: {
    ...mapState("layout", {
       eocTabs: state => state.eocTabs
     }),
    selectedEoc: {
      get() {
        return this.form.eoc;
      },
      async set(newValue) {
        this.form.eoc = newValue;
      }
    },
    selectedLocation: {
      get() {
        return this.form.location;
      },
      async set(newValue) {
        this.form.location = newValue;
      }
    }
  },
  watch: {
    "form.eoc": function(newValue, oldValue) {
      if (newValue != oldValue){
        this.formErrors.eoc = [];
        this.formErrors.location = [];
        this.formErrors.tabOpen = [];
      }
    }
  }
};
</script>
